"use strict";

require("core-js/modules/es.array.includes.js");
require("core-js/modules/es.string.includes.js");
require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SVBHeaderMobile;
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.replace.js");
require("core-js/modules/esnext.iterator.map.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _svbReactComponents = require("@svb/svb-react-components");
var _Search_grey = _interopRequireDefault(require("@svb/svbbranding/dist/assets/icons/Search_grey.svg"));
var _reactRouterDom = require("react-router-dom");
var _SVBAPIDocsMenu = require("../../../react-molecule/SVBAPIDocsMenu");
var _Menu = _interopRequireDefault(require("@svb/svbbranding/dist/assets/icons/Menu.png"));
var _closeMobile = _interopRequireDefault(require("@svb/svbbranding/dist/assets/icons/closeMobile.png"));
var _SVBHeader = require("../../SVBHeader");
const _excluded = ["logo", "headerContent"];
/* istanbul ignore file */
/* eslint-disable */
/*
 * SVB HeaderMobile
 * <SVBHeader headerContent={headerJSON} />
 */
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
/**
 * SVBHeaderMobile
 * @param headerContent: json array of header-link objs
 * @returns header HTML with content
 */

function SVBHeaderMobile(_ref) {
  let {
      logo,
      headerContent
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const {
    onSearchClick,
    showSearch
  } = props;
  const menu = props.menu;
  const [isShowNavLinks, setIsShowNavLinks] = (0, _react.useState)(false);
  const [cParentIndex, setcParentIndex] = (0, _react.useState)('');
  const [cParentActive, setcParentActive] = (0, _react.useState)(false);
  const [cChildActiveIndex, setcChildActiveIndex] = (0, _react.useState)('');
  const cpath = location.pathname;
  (0, _react.useEffect)(() => {
    const parentObj = (0, _SVBHeader.GetParentObject)(headerContent, 'link');
    setcParentIndex(parentObj === null || parentObj === void 0 ? void 0 : parentObj.parentRouteName);
    setcParentActive(true);
  }, []);
  (0, _react.useEffect)(() => {
    setcChildActiveIndex(cpath);
  }, [cpath]);
  const onhandleChange = parentRouteName => {
    if (cParentIndex !== parentRouteName) {
      // When the route is new
      setcParentIndex(parentRouteName);
      setcParentActive(true);
    } else {
      // When the route hasn't changed
      setcParentIndex(parentRouteName);
      setcParentActive(!cParentActive);
    }
  };
  const hideHamburgerMenu = () => {
    setcParentActive(false);
    setIsShowNavLinks(!isShowNavLinks);
    const parentObj = (0, _SVBHeader.GetParentObject)(headerContent, 'link');
    setcParentIndex(parentObj === null || parentObj === void 0 ? void 0 : parentObj.parentRouteName);
    setTimeout(() => {
      setcParentActive(true);
    }, 100);
  };
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("nav", {
    className: "navbar-mobile"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "containerMenuMobile"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "hamburger",
    onClick: hideHamburgerMenu
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: isShowNavLinks ? _closeMobile.default : _Menu.default,
    alt: "SVB Developer Portal",
    width: 24,
    height: 24
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "svb-mobile-logo"
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    to: "/",
    onClick: isShowNavLinks ? hideHamburgerMenu : ''
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: logo,
    alt: "SVB Developer Portal",
    width: 191,
    height: 50
  })), showSearch && /*#__PURE__*/_react.default.createElement("div", {
    className: "search-mobile"
  }, /*#__PURE__*/_react.default.createElement("a", {
    href: "#",
    onClick: onSearchClick
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _Search_grey.default,
    alt: "search icon",
    role: "presentation",
    width: "20",
    height: "20"
  })))), /*#__PURE__*/_react.default.createElement("div", {
    className: isShowNavLinks ? 'menu-items transformMenu mx-0' : 'menu-items mx-0'
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex justify-content-between px-4"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "accordion",
    id: "accordionExample"
  }, headerContent && headerContent.map((item, index) => {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "accordion-item",
      key: index
    }, item.link ? /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
      to: item.link,
      onClick: () => {
        onhandleChange(item.parentRouteName);
        hideHamburgerMenu();
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "accordion-header",
      id: item.name
    }, /*#__PURE__*/_react.default.createElement("button", {
      className: "accordion-button menuNavigation ".concat(cParentIndex === item.parentRouteName ? cParentActive ? '' : 'collapsed' : 'collapsed'),
      type: "button",
      "data-bs-toggle": "collapse",
      "data-bs-target": "#".concat(item.parentRouteName),
      "aria-expanded": "".concat(cParentIndex === item.parentRouteName ? cParentActive : 'false'),
      "aria-controls": item.parentRouteName
    }, /*#__PURE__*/_react.default.createElement(_svbReactComponents.SVBTypography, {
      type: "heading-small",
      variant: "mobile-submenu"
    }, item.name))), /*#__PURE__*/_react.default.createElement("div", {
      id: item.parentRouteName,
      className: "accordion-collapse collapse",
      "aria-labelledby": item.name,
      "data-bs-parent": "#accordionExample"
    })) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("h2", {
      className: "accordion-header",
      id: item.name,
      onClick: () => {
        onhandleChange(item.parentRouteName);
      }
    }, /*#__PURE__*/_react.default.createElement("button", {
      className: "accordion-button ".concat(cParentIndex === item.parentRouteName ? cParentActive ? '' : 'collapsed' : 'collapsed'),
      type: "button",
      "data-bs-toggle": "collapse",
      "data-bs-target": "#".concat(item.parentRouteName),
      "aria-expanded": "".concat(cParentIndex === item.parentRouteName ? cParentActive : 'false'),
      "aria-controls": item.parentRouteName
    }, /*#__PURE__*/_react.default.createElement(_svbReactComponents.SVBTypography, {
      type: "heading-small",
      variant: "mobile-submenu"
    }, item.name))), /*#__PURE__*/_react.default.createElement("div", {
      id: item.parentRouteName,
      className: "accordion-collapse collapse ".concat(cParentIndex === item.parentRouteName ? cParentActive ? 'show' : '' : ''),
      "aria-labelledby": item.name,
      "data-bs-parent": "#accordionExample"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "accordion-body"
    }, item.parentRouteName == 'apis' ? /*#__PURE__*/_react.default.createElement(_SVBAPIDocsMenu.SVBAPIDocsMenu, {
      extraClasses: 'col-md-12 w-100',
      data: menu,
      mobileProps: "true",
      onhandleChange: hideHamburgerMenu
    }) : /*#__PURE__*/_react.default.createElement("div", {
      className: "svb-mobile-sidemenu svb-api-docs-sidebar"
    }, /*#__PURE__*/_react.default.createElement("nav", {
      className: "sidebar-nav sidebar-mobile-nav"
    }, /*#__PURE__*/_react.default.createElement("ul", {
      className: "sidebar-nav-items"
    }, item.subMenu.map((item, i) => {
      return /*#__PURE__*/_react.default.createElement("li", {
        key: i,
        className: "sidebar-nav-item ".concat(cChildActiveIndex.replace(/\/+$/, '') === item.link ? 'sidebar-nav-item--active' : '')
      }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
        className: "sidebar-title",
        to: item.link,
        onClick: () => {
          hideHamburgerMenu();
        }
      }, item.name));
    }))))), /*#__PURE__*/_react.default.createElement("div", null))));
  }))))));
}